import React, { useState } from 'react'
import '../../styles/scss/components/equote-preview-package-navigation.scss'
import triggerCustomGaEvent from '../../utils/triggerCustomGaEvent'

const links = [
  {
    text: 'ITINERARY & DESTINATION',
    target: 'itinerary',
    gaTitle: 'itineraryDestination'
  },
  {
    text: 'SHIP INFORMATION',
    target: 'ship',
    gaTitle: 'shipInformation'
  },
  {
    text: 'STATEROOM INFORMATION',
    target: 'staterooms',
    gaTitle: 'stateroomInformation'
  },
  {
    text: 'SIMILAR SAILINGS',
    target: 'similar-sailings',
    gaTitle: 'similarSailing'
  },
  {
    text: 'Request Sailing',
    target: 'request',
    gaTitle: 'requestSailingTab'
  }
]

const EQuotePreviewPackageNavigation = () => {
  const [activeIndex, setActiveIndex] = useState(null)
  return (
    <div className="equote-preview-package-navigation">
      {links.map((link, i) => {
        return (
          <button
            key={link.target}
            className={`equote-preview-package-navigation--button btn ${
              i === activeIndex ? 'active' : ''
            }`}
            onClick={() => {
              const target = document.getElementById(link.target)
              if (target) {
                setActiveIndex(() => i)
                target.scrollIntoView({ behavior: 'smooth' })
              }
              if (link.gaTitle) {
                triggerCustomGaEvent(`sailingPreview-${link.gaTitle}`, true)
              }
            }}
          >
            {link.text}
          </button>
        )
      })}
    </div>
  )
}

export default EQuotePreviewPackageNavigation
